import React from "react";
import { Link } from "react-router-dom";
import "./Sec3.css";

function Sec3() {
  return (
    <section className="twoColoumnsec3">
      <div className="innerSec3 C-bg">
        <div className="mainHeading"> Theme of Over Company </div>
        <div className="textPan1 secondary_bg circleCommon">
          <div className="subHeading ">Our Mission</div>
          <p className="para">
            "Our mission is to spread joy and creativity through our beautiful
            balloon artistry. We are dedicated to crafting innovative and
            imaginative balloon designs that not only bring smiles but also
            ignite creativity. Our goal is to uplift spirits, spark
            celebration."
          </p>
          <Link to="/AboutUs" className="cta"> KNOW MORE</Link>
        </div>
        <div className="textPan2 primary_bg circleCommon">
          <div className="subHeading">Team of Experts</div>
          <p className="para">
          " Our success in this domain is attributed to our dedicated team
 members who put in untiring efforts to offer our clients a quality
 range of inflatable products. We owe it to their expertise and
 in-depth knowledge in their respective field, which enables us to
 meet the bulk requirements of our clients. They are also well-versed
 in the ever-changing trends of the market and manufacture products
 accordingly, which helps us attain client satisfaction."
          </p>
          <Link to="/AboutUs" className="cta"> KNOW MORE</Link>
        </div>

        <div className="textPan3 secondary_bg circleCommon">
          <div className="subHeading">Customer-Centric Approach</div>
          <p className="para">
          "Our customers are at the center of everything we do. We prioritize your 
            satisfaction by [ Learn and improve customer expectations and take 
            customers feedback.] ensuring an unparalleled experience."
          </p>
          <Link to="/AboutUs" className="cta"> KNOW MORE</Link>
        </div>
      </div>
    </section>
  );
}

export default Sec3;
